module.exports = __webpack_public_path__ + "img/voucher.24dcc810.png";